/**
 * Centralized application configuration.
 * All environment variables and external URLs referenced in one place.
 */

export const MAPBOX_DIRECTIONS_URL = 'https://api.mapbox.com/directions/v5/mapbox/walking';
export const MAPBOX_RTL_PLUGIN_URL = 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.3.0/mapbox-gl-rtl-text.js';
export const MAPBOX_TOKEN: string | undefined = import.meta.env.VITE_MAPBOX_TOKEN;

export const FIREBASE_CONFIG: {
  apiKey: string | undefined;
  authDomain: string | undefined;
  projectId: string | undefined;
  storageBucket: string | undefined;
  messagingSenderId: string | undefined;
  appId: string | undefined;
} = {
  apiKey: import.meta.env.VITE_FB_API_KEY,
  authDomain: import.meta.env.VITE_FB_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FB_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FB_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FB_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FB_APP_ID,
};

export const USE_EMULATORS: boolean = import.meta.env.VITE_USE_EMULATORS === 'true';

export const ANNEFRANK_CHAT_URL: string | undefined = import.meta.env.VITE_ANNEFRANK_CHAT_URL;

export const AGENT_URL: string | undefined = import.meta.env.VITE_AGENT_URL;
